<div
  id="overrides-history-dialog"
  [ngClass]="{ 'handson-table-tooltip': true, 'tooltip-inverse': !data.overrideCellInfo }"
  [style.height]="config.data.height"
  [style.width]="config.data.width"
>
  @if (data.overrideCellInfo) {
  <p class="hRow">
    <b>{{ data.calculatedValue }}</b> {{ 'app.advertising.calculated.value.message' | translate }}
  </p>
  } @if (data.overrideCellInfo) {
  <p class="hRow description">
    <b>{{ data.overrideCellInfo.overriddenValue }}</b> {{ data.overrideCellInfo.username }} -
    {{ lastUpdated }}
  </p>
  } @if (!data.overrideCellInfo) {
  <p>
    {{ 'app.advertising.no.override.history.available.message' | translate }}
  </p>
  }
</div>
